// Styles
import '@styles/app.css';

// Commons
import header from '@commons/header';
import main from '@commons/main';

// Vue instances
import SearchIndex from '@vue-instances/SearchIndex';

// Entry point logic
export default async function init() {
  header();
  main();

  // Vue instances
  SearchIndex();
}

init();
